import { DiagnosticCompanyStorageService } from './../../../shared/services/storage/diagnostic-company-storage.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { pagingDefaultSettings } from '../../../shared/directives/sortable-table-header.directive';
import { Helper } from '../../../shared/helpers/helper';
import { Subscription } from 'rxjs';
import { CPATTERN, DIAGNOSTIC_DEFAULTS } from '../../../shared/helpers/app.constants';
import { NbDialogService } from '@nebular/theme';
import { DiagnosticPointsService } from '../../../shared/services';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { DiagnosticsFormModalComponent } from './diagnostics-form-modal.component';

@Component({
  selector: 'app-diagnostics',
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.scss']
})
export class DiagnosticsComponent implements OnInit, OnDestroy {
  curCompanyId: number;
  subscriptions: Subscription[] = [];
  formAdding: FormGroup;
  diagnosticName: AbstractControl;

  pageState = {
    submitting: false,
    loading: false,
    isShowCompanySelector: false,
  };

  pagingState = { ...pagingDefaultSettings };

  @Input() dataSource = [];
  @Input()
  set companyId(id: number) {
    if (this.curCompanyId !== id) {
      this.curCompanyId = id;
      // load data by company
      this.loadDataTable(this.curCompanyId);
    }
  }

  constructor(
    private nbDialogService: NbDialogService,
    private diagnosticPointsService: DiagnosticPointsService,
    private diagnosticCompanyStorageService: DiagnosticCompanyStorageService,
    private fb: FormBuilder,
  ) { }

  get dataTable(): any[] {
    const result = this.dataSource.slice(
      (this.pagingState.page - 1) * this.pagingState.pageSize,
      (this.pagingState.page - 1) * this.pagingState.pageSize + this.pagingState.pageSize
    );
    return result;
  }

  ngOnInit(): void {
    // this.pageState.loading = true;
    this.createAddingForm();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  createAddingForm() {
    this.formAdding = this.fb.group({
      diagnosticName: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(CPATTERN.CHANNEL_MAPPING_NAME)]
      ]
    });
    this.diagnosticName = this.formAdding.controls['diagnosticName'];
  }

  loadDataTable(companyId) {
    const currentCompanyId = companyId ? companyId : '';
    this.pageState.loading = true;
    const companyStorage = this.diagnosticCompanyStorageService.getCompanyStorage(currentCompanyId);
    if (companyStorage) {
      this.handleDataTable(companyStorage);
      this.pageState.loading = false;
    } else {
      this.subscriptions.push(
        this.diagnosticPointsService.getByCompany(currentCompanyId)
          .subscribe(res => {
            if (res && res.result) {
              this.diagnosticCompanyStorageService.setCompanyStorage(companyId, res.result);
              this.handleDataTable(res.result);
            }
            this.pageState.loading = false;
          }, err => {
            this.pageState.loading = false;
          })
      );
    }
  }

  handleDataTable(data: any[]) {
    let result = [];
    if (data && data.length > 0) {
      // sort by id desc
      result = data.sort((leftItem, rightItem) => {
        if (leftItem.id > rightItem.id) {
          return -1;
        }
        return 1;
      });
    }
    this.dataSource = this.getDefaultDiagnostics().concat(result);
    this.pagingState.collectionSize = this.dataSource.length;
  }

  onAddItem(event?) {
    if (this.formAdding.valid && this.diagnosticName.value.trim()) {
      this.pageState.submitting = true;
      const reqPayload = {
        name: this.diagnosticName.value,
        color: Helper.getRandomColor()
      };
      this.subscriptions.push(
        this.diagnosticPointsService.createByCompany(this.curCompanyId, reqPayload, () => {
          this.pageState.submitting = false;
        }).subscribe(res => {
          this.formAdding.reset();
          this.diagnosticCompanyStorageService.removeCompanyStorage(this.curCompanyId);
          this.loadDataTable(this.curCompanyId);
        })
      );
    }
  }

  showEdit(event, item) {
    this.nbDialogService.open(DiagnosticsFormModalComponent, {
      autoFocus: false,
      context: {
        selectedItem: { ...item },
        currentCompanyId: this.curCompanyId ? this.curCompanyId : ''
      }
    })
      .onClose
      .subscribe(data => {
        if (data) {
          this.diagnosticCompanyStorageService.removeCompanyStorage(this.curCompanyId);
          this.loadDataTable(this.curCompanyId);
        }
      });
  }

  delete(event, item) {
    this.nbDialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.name}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
        }
      }
    })
      .onClose
      .subscribe(response => {
        if (response && response.confirm && item && item.id) {
          const currentCompanyId = this.curCompanyId ? this.curCompanyId : '';
          this.pageState.loading = true;
          this.subscriptions.push(
            this.diagnosticPointsService.deleteByCompany(currentCompanyId, item.id)
              .subscribe(res => {
                this.diagnosticCompanyStorageService.removeCompanyStorage(this.curCompanyId);
                this.loadDataTable(currentCompanyId);
              }, err => {
                this.pageState.loading = false;
              })
          );
        }
      });
  }

  getDefaultDiagnostics() {
    const result = DIAGNOSTIC_DEFAULTS.map(defaultPoint => {
      return {
        id: defaultPoint.id,
        name: defaultPoint.text,
        color: defaultPoint.color || Helper.randomHexColor(),
        isDefault: true
      };
    });
    return result;
  }

}
